import { QuestionCircleOutlined } from '@ant-design/icons'
import { Radio, Tooltip } from 'antd'
import classNames from 'classnames'
import { useAtom } from 'jotai'
import { MyForm } from '~/components/ui/MyForm'
import { selectResolutionAtom, selectSizeAtom } from './atom'
import styles from '../AiForm.module.css'
import useOptions from './useOptions'
import { useSetDefaultPaintParams } from './useSetDefaultPaintParams'
import { SuperType } from '~/graphqls/types'

export const PictureSizeComp = () => {
  const [selectSize, setSelectSize] = useAtom(selectSizeAtom)
  const { curResolution, curModelTheme } = useOptions()
  const [selectResolution, setSelectResolution] = useAtom(selectResolutionAtom)

  const { curSizeOptions } = useOptions()
  const setDefaultPaintParams = useSetDefaultPaintParams()
  const curResolutionOptions = curResolution[selectSize] || []

  const handleResolutionChange = (str: string) => {
    if (str.endsWith(`*${SuperType.FOUR_K}`) && curModelTheme?.fourKDefault) {
      setDefaultPaintParams(curModelTheme?.fourKDefault)
    }
    setSelectResolution(str)
  }

  // https://www.tapd.cn/57191511/prong/stories/view/1157191511001032445 @艾海军
  // 改变size时，优先选择size下对应的 index 和 superType 都相同的 resolution （superType优先级大于index）
  // 例如 如果当前resolution选择了精绘/4k，优先选择size下对应的精绘/4k尺寸
  //     如果当前index为4，优先选择第4个resolution
  // 如果没有找到对应的精度 按照原逻辑执行
  const handleSizeChange = (size: string) => {
    setSelectSize(size)
    const nextResolutionOptions = curResolution[size] || []
    if (nextResolutionOptions.length === 0) return
    const curResolutionSuffix = selectResolution.split('*')[2]
    let curIndex = curResolutionOptions.findIndex(
      item =>
        `${item.length}*${item.width}*${item.superType}` === selectResolution
    )
    let nextResolution: any = nextResolutionOptions[curIndex]
    if (nextResolution.superType !== curResolutionSuffix) {
      nextResolution = nextResolutionOptions.find(
        it => it.superType === curResolutionSuffix
      )
    }
    if (nextResolution) {
      handleResolutionChange(
        `${nextResolution.length}*${nextResolution.width}*${nextResolution.superType}`
      )
    }
  }

  return (
    <MyForm.Item
      label={
        <span>
          * 画面大小{' '}
          <Tooltip
            placement="topLeft"
            arrowPointAtCenter
            title="人物类的图片推荐使用 1:1的方图，景观类的图片推荐使用其他比例的尺寸"
          >
            <QuestionCircleOutlined />
          </Tooltip>
        </span>
      }
      className={classNames(styles.borderLessFormItem, '!mb-1')}
    >
      <Radio.Group
        className={styles.customRadioGroup}
        onChange={e => {
          handleSizeChange(e.target.value)
        }}
        value={selectSize}
      >
        {curSizeOptions.map(item => {
          return (
            <Radio
              value={item?.name}
              key={item?.name}
              className={styles.customRadio}
              disabled={item?.disabled}
            >
              <div
                className={classNames(
                  'flex flex-col items-center justify-center cursor-pointer border-2 border-solid border-neutral-200 rounded-xl duration-75  flex-1 p-3 bg-neutral-200 w-full',
                  styles.radioBtn,
                  {
                    'opacity-50 !cursor-not-allowed': item?.disabled,
                  }
                )}
              >
                <img
                  alt=""
                  src={item?.url}
                  className="w-[30px] h-[30px] block"
                />
                <div className="text-neutral-800 font-semibold mt-2 !leading-none">
                  {item?.name}
                </div>
                <div className="text-neutral-500 text-[12px] mt-1 !leading-none">
                  {item?.desc}
                </div>
              </div>
            </Radio>
          )
        })}
      </Radio.Group>
    </MyForm.Item>
  )
}
